// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    suggestionMobileStyle: 'style2'
  }
};

(function() {
  var metafields = {
    'title': ''
  };

  BoostPFS.inject(this);

  function prepareShopifyData(data) {
    if (data.hasOwnProperty('metafields')) {
      var namespace = 'accentuate';
      metafields.title = Utils.getProductMetafield(data, namespace, 'title');
    } else {
      metafields = {
        'title': ''
      };
    }

    return data;
  }
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  InstantSearchResult.prototype._applyFilterAutocompleteAppendElement = function() {
    if (this.searchInputId == 'boost-pfs-search-box-0') {
      this.appendToSelector = '[data-header-search]'; // search in the header
    } else if (this.searchInputId == 'boost-pfs-search-box-1') {
      this.appendToSelector = '[data-search-page-form]'; // search results page
    }
  };

  InstantSearchResultItemProduct.prototype.compileTemplate = function(data) {
    if (!data) data = this.data;
    data = prepareShopifyData(data);

    var html = `
      <li class="boost-pfs-search-suggestion-item boost-pfs-search-suggestion-item-product boost-pfs-ui-item" data-id="{{id}}" role="option">
        <a href="{{url}}" tabindex="0">
          <div class="boost-pfs-search-suggestion-left">
            {{image}}
          </div>
          <div class="boost-pfs-search-suggestion-right">
            <h3 class="boost-pfs-search-suggestion-product-title">{{title}}</h3>
            <p class="boost-pfs-search-suggestion-product-type">{{type}}</p>
          </div>
        </a>
      </li>
    `;

    // Image
    html = html.replace(/{{image}}/g, buildImages(data));

    // Title
    html = html.replace(/{{title}}/g, buildTitle(data));

    // Product Type
    html = html.replace(/{{type}}/g, buildProductType(data));

    // URL
    var productUrl = Utils.buildProductItemUrl(data);
    if (productUrl.includes('collections//products')) {
      productUrl = productUrl.replace('collections//', '')
    }
    html = html.replace(/{{url}}/g, productUrl);

    // ID
    html = html.replace(/{{id}}/g, data.id);

    return html.trim();
  };

  InstantSearchResult.prototype.afterRender = function() {
    const panel = document.querySelector('.boost-pfs-search-suggestion')
    if (panel) {
      panel.removeAttribute('tabindex')

      setTimeout(() => {
        panel.querySelectorAll('a').forEach((el) => {
          el.setAttribute('tabindex', 0)
        })
      }, 100)
    }
  };

  function buildImages(data) {
    var html = '';
    var images = data.images_info;

    if (!images || images.length == 0){
      images.push({
          src: boostPFSAppConfig.general.no_image_url,
          width: 340,
          height: 340
      });
    }

    var productImageSrc = Utils.optimizeImage(data.images_info[0].src, '170x230');
    var productImageAlt = data.images_info[0].alt;
    html = `<img src="${productImageSrc}" alt="${productImageAlt}" width="85" height="115" />`;

    return html;
  }

  function buildTitle(data) {
    var customTitle = metafields.hasOwnProperty('title') ? metafields.title : false

    if (customTitle) {
      return customTitle;
    } else {
      return data.title;
    }
  }

  function buildProductType(data) {
    var productType = '';
    var lowercaseTitle = data.title.toLowerCase();

    if (lowercaseTitle.includes('top') || data.tags.includes('type-top')) {
      productType = 'Top';
    } else if (lowercaseTitle.includes('bottom') || data.tags.includes('type-bottom')) {
      productType = 'Bottom';
    }

    return productType;
  }

  // Autofocus
  $('[data-search-button-open]').on('click', function() {
    $('[data-header-search-input]').removeAttr('aria-label').attr('placeholder', '').focus();
    $('[data-header-search-input], [data-header-search-close]').attr('tabindex', 0);
  });

  $('[data-header-search-close]').on('click', function() {
    $('[data-header-search-input], [data-header-search-close]').attr('tabindex', -1);
  });

  Utils.buildProductItemUrl = function(data, hasCollection) {
    // Get url information
    var params = Utils.getWindowLocation().search.substring(1);
    var pathname = window.location.pathname;
    var elements = pathname.split('/');

    // Check if has locale
    var localeURLPart = "";
    var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
    if (Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') && hasShopifyRoutes) {
      localeURLPart = Shopify.routes.root.replace(/\/$/, '');
    } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
      localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
    }

    // Get product handle
    var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
    var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
    if (hasCollection) {
      // Homepage or Search page
      if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
        var preHandle = localeURLPart + '/collections/all/products/';
        return preHandle + handle;

        // Tag Page
      } else if (Utils.isTagPage()) {
        var preHandle = localeURLPart + '/collections/';
        var collectionHandleIndex = elements.indexOf("collections") + 1
        if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
        return '/collections/all/products/' + handle;
      } else {
        // Google cache URL
        // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
        if (params.indexOf('cache:') > -1) {
          var collectionHandle = 'all';
          var temp = params.split('&')[0].split('?')[0].split('collections/');
          if (temp.length > 1) {
            if (temp[1].indexOf('/') > -1) {
              collectionHandle = temp[1].split('/')[0];
            } else {
              collectionHandle = temp[1];
            }
          }
          collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
          return '/collections/' + collectionHandle + '/products/' + handle;
        }
        var collectionHandleIndex = elements.indexOf("collections") + 1;
        var preHandle = localeURLPart + '/collections/';

        if (typeof elements[2] !== 'undefined') {
          // Build for collection pages
          if ((localeURLPart == '' && elements[1] === 'collections') || localeURLPart != '') {
            return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
          }
          //Build for other pages, use collection/all
          return preHandle + 'all' + elements[collectionHandleIndex] + '/products/' + handle;
        } else if (typeof elements[2] === 'undefined' && localeURLPart == '') {
          return '/products/' + handle;
        }
        return window.location.pathname + '/products/' + handle;
      }
    }
    return localeURLPart + '/products/' + handle;
  };

  // InstantSearchResultItemProduct.prototype.afterRender = function() {
  //     if (this.hasOwnProperty('data') && this.data !== null) {
  //         var data = this.data;
  //         var currentUrl = Utils.getWindowLocation();
  //         var quickUrl = '/products/' + data.handle + '?view=boost-pfs-prices';
  //         jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').empty();
  //         jQ.ajax({
  //             url: quickUrl,
  //             success: function(result) {
  //                 jQ('.boost-pfs-search-suggestion-item[data-id="' + data.id + '"] .boost-pfs-search-suggestion-product-price').html(result)
  //             }
  //         });
  //     }
  // }
 /* Boost - 229068 */
  InstantSearchApi.beforeCall = function(eventType, eventInfo) {
    /* Change the filter params before calling api */
     var hiddenOptions = ["not-pre-order"];
      Globals.instantSearchQueryParams.h_options = hiddenOptions;
      /* No need to return anything */
    if (Shopify && Globals) {
        Globals.instantSearchQueryParams.currency = Shopify.currency.active
        Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate
        Globals.instantSearchQueryParams.country = Shopify.country
    }
  }
   /* Boost - 229068 */
})();

document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('#boost-pfs-search-box-0');
  searchInput.addEventListener('focus', () => {
    if (searchInput.classList.contains('focus-visible')) {
      setTimeout(() => {
          searchInput.click(); 
      }, 500); 
    }
  });
});
